import React from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { handleGetUsers } from "../utils";
import { useSelector } from "react-redux";
const RightSideDrawer = ({
  open,
  onClose,
  selectedField,
  onAssignUser,
  onDelete,
  onDone,
  onUpdateValue,
}) => {
  const docDetail = useSelector((item) => item.Docs.docDetail);

  if (!selectedField) return null;

  const handleUserChange = (event) => {
    onAssignUser(
      selectedField.id,
      event.target.value,
      handleGetUsers(docDetail?.data)?.find(
        (user) => user.id === event.target.value
      )
    );
  };

  const handleValueChange = (event) => {
    onUpdateValue(selectedField.id, event.target.value);
  };

  const handleCheckboxChange = (event) => {
    onUpdateValue(selectedField.id, event.target.checked);
  };

  const renderFieldSpecificControls = () => {
    switch (selectedField.tabType) {
      case "TextBox":
        return (
          <TextField
            fullWidth
            label="Text Value"
            variant="outlined"
            value={selectedField.value || ""}
            onChange={handleValueChange}
            margin="normal"
            multiline
            size="small"
            sx={{ fontSize: "13px" }}
          />
        );
      case "Date":
        return (
          <TextField
            fullWidth
            label="Date"
            type="date"
            variant="outlined"
            value={selectedField.value || ""}
            onChange={handleValueChange}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            size="small"
            sx={{ fontSize: "13px" }}
          />
        );
      case "Checkbox":
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={!!selectedField.value}
                onChange={handleCheckboxChange}
              />
            }
            label="Checked"
          />
        );
      default:
        return null;
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      variant="persistent"
      hideBackdrop
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "220px",
          backgroundColor: "#e6ebee",
          padding: 2,
          // position: "relative",
          border: "1px solid #e0e0e0",
          marginTop: "183px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontSize: "12px" }}>
          {selectedField.tabType} Field
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      <FormControl fullWidth margin="normal">
        <InputLabel id="assign-user-label">Assign To User</InputLabel>
        <Select
          labelId="assign-user-label"
          value={selectedField.user?.id || ""}
          label="Assign To User"
          onChange={handleUserChange}
          size="small"
          sx={{
            fontSize: "13px !important",
          }}
        >
          {handleGetUsers(docDetail?.data).map((user) => (
            <MenuItem
              sx={{
                fontSize: "13px !important",
              }}
              key={user.id}
              value={user.id}
            >
              {user?.full_name || user?.first_name} ({user?.userType})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {renderFieldSpecificControls()}

      <Box
        sx={{ display: "flex", flexDirection: "column", mt: 4, gap: "12px" }}
      >
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => onDelete(selectedField.id)}
          fullWidth
          sx={{ fontSize: "12px", textTransform: "capitalize" }}
        >
          Delete
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => onDone(selectedField.id)}
          size="small"
          fullWidth
          sx={{ fontSize: "12px", textTransform: "capitalize" }}
        >
          Done
        </Button>
      </Box>
    </Drawer>
  );
};

export default RightSideDrawer;
